<div class="col-lg-8 col-xl-9 order-lg-first">

  <!-- Header dos resultados -->
  <div class="results-header" *ngIf="!fetchingData && produtos?.length > 0">
    <div class="results-info">
      <h3 class="results-count">
        <span class="count-number">{{ produtos.length }}</span>
        {{ produtos.length === 1 ? 'produto encontrado' : 'produtos encontrados' }}
      </h3>
      <p class="results-total" *ngIf="totalProdutos > produtos.length">
        de {{ totalProdutos }} no total
      </p>
    </div>

    <!-- Você pode adicionar filtros/ordenação aqui -->
    <!-- <div class="results-actions">
      <p-dropdown [options]="sortOptions" placeholder="Ordenar por"></p-dropdown>
    </div> -->
  </div>

  <!-- Grid de produtos -->
  <div class="products-grid">
    <div class="product-card-wrapper" *ngFor="let produto of produtos">
      <article class="product-card">

        <!-- Imagem do produto -->
        <div class="product-image-container">
          <img class="product-image" (click)="detalhes(produto); $event.stopPropagation()"
            [src]="produto.imagem?.url ? produto.imagem?.url : imagemPadrao" [alt]="produto?.nome" loading="lazy" />

          <span *ngIf="isMyFavorite(produto?.ean); else noFavorite" class="favorite-button is-favorite"
            (click)="setFavorite(produto.ean)" [attr.aria-label]="'Remover dos favoritos'">
            <a class="button-icon button-icon-only">
              <i class="fas fa-heart fa-lg"></i>
            </a>
          </span>

          <ng-template #noFavorite>
            <span class="favorite-button" (click)="setFavorite(produto.ean)"
              [attr.aria-label]="'Adicionar aos favoritos'">
              <a class="button button-icon button-icon-only">
                <i class="far fa-heart fa-lg"></i>
              </a>
            </span>
          </ng-template>
        </div>

        <!-- Informações do produto -->
        <div class="product-info">

          <!-- Marca -->
          <div class="product-brand" (click)="detalhes(produto); $event.stopPropagation()">
            {{ produto?.marca?.nome || produto?.marca }}
          </div>

          <!-- Nome do produto -->
          <h4 class="product-name" (click)="detalhes(produto); $event.stopPropagation()">
            {{ produto?.nome | ellipsis:81}}
          </h4>

          <!-- Rating e negociações -->
          <div class="product-meta">
            <button class="negotiations-link" (click)="negociacoes(produto); $event.stopPropagation()">
              <i class="fas fa-handshake"></i>
              {{ produto?.negociacoes_ativas||0 }} {{ 'negociacoes' | transloco }}
            </button>
            <app-rating (click)="avaliacoes(produto); $event.stopPropagation()" [rating]="produto?.averageRating || 0"
              [avaliacoes]="produto?.totalReviews || 0">
            </app-rating>

          </div>
          <span *ngIf="isCompatibleWithMineVehicle(produto?.ean)">
            <i class="fas fa-check-circle compatible-icon text-success"></i>
            Compatível com seu veículo
          </span>
          <!-- Botões de ação -->
          <div class="product-actions">
            <a class="mt-0 button button-icon button-icon-only" (click)="wantToBuy(produto); $event.stopPropagation()"
              [attr.aria-label]="'cartao_produto_comprar' | transloco">
              {{ 'cartao_produto_comprar' | transloco }}
              <i class="ml-2 fa-solid fa-cart-plus"></i>
            </a>

            <a class="mt-0 button button-icon button-icon-only" (click)="wantToSell(produto); $event.stopPropagation()"
              [attr.aria-label]="'cartao_produto_vender' | transloco">
              {{ 'cartao_produto_vender' | transloco }}
              <i class="ml-2 fa fa-box"></i>
            </a>
          </div>
        </div>
      </article>
    </div>
  </div>

  <!-- Estados vazios e carregamento -->
  <div class="results-footer">

    <!-- Loading -->
    <div class="loading-state" *ngIf="fetchingData">
      <app-spinner [show]="fetchingData"></app-spinner>
      <p class="loading-text">Carregando produtos...</p>
    </div>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="!fetchingData && produtos?.length === 0">
      <div class="empty-icon">
        <i class="fas fa-search"></i>
      </div>
      <h3 class="empty-title">Nenhum produto encontrado</h3>
      <p class="empty-description">
        Tente ajustar os filtros ou realizar uma nova busca
      </p>
    </div>

    <!-- Informações de paginação -->
    <div class="pagination-info" *ngIf="!fetchingData && produtos?.length > 0">
      <p class="showing-text" *ngIf="produtos?.length === totalProdutos">
        {{ 'mostrando_produtos' | transloco : { numero: totalProdutos } }}
      </p>

      <button *ngIf="produtos?.length < totalProdutos" type="button" class="load-more-button" (click)="fetchData()">
        <span>Ver mais produtos</span>
        <i class="fas fa-chevron-down"></i>
      </button>

      <div class="progress-indicator" *ngIf="produtos?.length < totalProdutos">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="(produtos.length / totalProdutos) * 100">
          </div>
        </div>
        <p class="progress-text">
          {{ produtos.length }} de {{ totalProdutos }} produtos carregados
        </p>
      </div>
    </div>
  </div>
</div>
